export default {
  name: 'Google Sheets',
  description: 'Embed a Google Sheets spreadsheet .',
  category: 'Google / Sheets',
  tags: ['spreadsheet', 'google sheets'],
  active: true,
  icon: 'fa-solid fa-file-excel',
  created_by: 'system',
  updated_by: 'system',
  created_at: '2023-05-05',
  version: 0,
  html: `<iframe src="" width="100%" height="100%" frameborder="0"></iframe>`,
  script: `$template.ready(async () => {
    const iframe = document.getElementsByTagName('iframe')[0];
    const view = $template.useView();
    view.showLoading();
    iframe.onload = () => {
      view.hideLoading();
    };
    iframe.onerror = () => {
      view.hideLoading();
      // view.showAlert('Error loading video', 'danger');
    }
    const variables = $template.useVariables();
    const url = await variables.getValue('Your_Document_URL');
    iframe.src = url;
  });  
  `,
  css: ``,
  variables: [
    {
      label: 'Document URL',
      name: 'Your_Document_URL',
      type: 'multilineString',
      defaultFieldValue:
        'https://docs.google.com/spreadsheets/d/1ZQ_TRKpjMgNO1pl3z95rJC8oQ0JM_xdAd0yBCwDwDWA/edit?usp=sharing',
      mandatory: true,
      description: 'Google Sheet Document URL',
      defaultVariable: true
    }
  ]
};
